const ADD_CONTACT = 'ADD_CONTACT'
const EDIT_CONTACT = 'EDIT_CONTACT'
const SET_CONTACTS = 'SET_CONTACTS'

export default {
  SET_CONTACTS,
  ADD_CONTACT,
  EDIT_CONTACT
}



// WEBPACK FOOTER //
// ./src/actionTypes/onboarding/contact.js